<template>
  <div ref="resize" class="drag-divider" :style="{width: width, height: height, background: background}"></div>
</template>

<script>
export default {
  name: "DyDragDivider",
  props: {
    width: {
      type: String,
      default: '8px'
    },
    height: {
      type: String,
      default: '100%'
    },
    background: {
      type: String,
      default: '#f4f4f4'
    },
    leftAsideWidth: {
      type: Number,
      default: 300
    },
    leftAsideMinWidth: {
      type: Number,
      default: 100
    },
    leftAsideMaxWidth: {
      type: Number,
      default: 1000
    },
  },
  mounted() {
    this.dragChangeRightAsideWidth()
  },
  methods: {
    dragChangeRightAsideWidth() {
      let resize = this.$refs.resize;
      resize.onmousedown = e => {
        let startX = e.clientX;
        resize.style.background = "#C6C7C9";
        resize.left = resize.offsetLeft;  // 记录距离父辈元素左边缘的距离
        let newWidth = this.leftAsideWidth
        let min = this.leftAsideMinWidth
        let max = this.leftAsideMaxWidth
        document.onmousemove = e2 => {
          // 计算并应用位移量
          let endX = e2.clientX;  // 记录赋值横坐标结束的位置
          let moveLen = startX - endX;   // 计算鼠标拖动之间的位移差
          if ((moveLen < 0 && this.leftAsideWidth < max) || (moveLen > 0 && this.leftAsideWidth > min)) {
            startX = endX;  // 当前值赋值给初始值
            newWidth -= moveLen;   // 侧边的宽度加（减）上拖动后的位移量，就是此时的宽度
            if (newWidth < this.min) {
              newWidth = this.min;
            }
            this.$emit('change', newWidth);
          }
        };
        document.onmouseup = () => {
          resize.style.background = this.background;
          document.onmousemove = null;
          document.onmouseup = null;
        };
        return false;
      };
    }
  }
}
</script>

<style scoped>
.drag-divider {
  cursor: col-resize;
}
</style>
